import { useState, type ReactElement } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useSearchParams } from 'react-router-dom';

import { useCreatePage } from '../hooks/useCreatePage';
import type { StandardPage } from '../standardPages';
import { AddPageModal } from './AddPageModal';

interface AddPageRowProps {
  websiteId: string;
  page: StandardPage;
}

// Placeholder row for a standard page the website has not created yet.
export function AddPageRow({ websiteId, page }: AddPageRowProps): ReactElement {
  const [searchParams] = useSearchParams();
  const organisationId = searchParams.get('organisationId') ?? '';
  const [isModalOpen, setIsModalOpen] = useState(false);
  const createPage = useCreatePage();

  return (
    <Box className="vtwo:flex vtwo:justify-between vtwo:items-center vtwo:px-6 vtwo:py-5 vtwo:rounded-xl vtwo:border-2 vtwo:border-plus-border vtwo:bg-white">
      <Box>
        <Typography className="vtwo:font-bold">{page.name}</Typography>
        <Typography variant="body2" className="vtwo:text-gray-500">
          This page has not been created yet
        </Typography>
      </Box>
      <Button
        variant="outlined"
        disabled={createPage.isLoading}
        onClick={() => setIsModalOpen(true)}
        className="vtwo:rounded-lg vtwo:text-featured vtwo:border-featured vtwo:hover:border-featured-hover vtwo:hover:bg-featured/[0.04]"
      >
        Add Page
      </Button>

      {isModalOpen && (
        <AddPageModal
          open
          pageName={page.name}
          organisationId={organisationId}
          isSaving={createPage.isLoading}
          onClose={() => setIsModalOpen(false)}
          onCreate={(seo) =>
            createPage.mutate(
              { websiteId, name: page.name, href: page.href, seo },
              { onSuccess: () => setIsModalOpen(false) }
            )
          }
        />
      )}
    </Box>
  );
}
